import axios from "axios";

const API_URL = process.env.REACT_APP_BASEURL;
const B_URL = process.env.REACT_APP_LOGINURL


const headers = {
  'Content-Type': 'application/json',
  'token': localStorage.getItem("session-id")
}


const getAll = (payload) => {
  const headers = {
    'Content-Type': 'application/json',
    'token': localStorage.getItem("session-id")
  }
  return axios.post(API_URL, payload, { headers });
};

const getInvoices = (payload) => {
  const headers = {
    'Content-Type': 'application/json',
    'token': localStorage.getItem("session-id")
  }
  console.log("getInvoices", getInvoices)
  return axios.post(B_URL + 'Request_E_InvoiceModule/' + payload.functionName, payload, { headers });
};

const Get_User_Invoices = (page, limit, business, user_id) => {
  var payload = {
    functionName: "Get_User_Invoices",
    postData: {
      filter: {},
      limit: limit,
      offset: page,
      user_id: user_id,
      business: business
    }
  }
  console.log("Get_User_Invoices", payload);
  return axios.post(B_URL + "E_invoiceFetchingModule/"+payload.functionName, payload, { headers });
};



const getAllStatements = (page, limit, filter) => {
  var payload = {
    functionName: "User_Record_Dashboard",
    Customer_ID: filter,
    limit: limit,
    offset: page
  }
  return axios.post(B_URL + "statements", payload, { headers });
};

const getAllBusiness = () => {
  var payload = {
    functionName: "GetBusinesses",
    postData: {
      limit: 9999999,
      offset: 0,
      business_ids: []
    }
  }
  return axios.post(B_URL + "BusinessModule/GetBusinesses", payload, { headers });
};

const getAllCategories = (page, limit, business_id) => {
  var payload = {
    functionName: "GetCategories",
    postData: {
      limit: limit,
      offset: page,
      business_id: business_id
    }
  }
  console.log("payload", payload);
  return axios.post(B_URL + "CategoryModule/GetCategories", payload, { headers });
};

const getAllProducts = (page, limit, Category, Branch) => {
  var payload = {
    functionName: "GetItems",
    postData: {
      filter: {},
      limit: limit,
      offset: page,
      category: Category,
      business: Branch
    }
  }
  console.log("GetItems", payload);
  return axios.post(B_URL + "ItemsRoutes/GetItems", payload, { headers });
};

const GetDashboardData = (payload, sessionID) => {
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + 'DashboardRoutes/GetDashboardData', payload, { headers });
};

const setCart = (payload) => {
  console.log("setCart", payload);
  return axios.post(B_URL + "CartModule/setCart", payload, { headers });
};
const GetCartList = (payload) => {
  console.log("GetCartList", payload);
  return axios.post(B_URL + "CartModule/GetCartList", payload, { headers });
};

const GetProducctDetails = (payload) => {
  console.log("GetProducctDetails", payload);
  return axios.post(B_URL + "ItemModule/SearchItem", payload, { headers });
};

const GeProductReviews = (payload) => {
  console.log("GeProductReviews", payload);
  return axios.post(B_URL + "OrderModule/ProductReviews", payload, { headers });
};

const DeleteCart = (payload) => {
  console.log("DeleteCart", payload);
  return axios.post(B_URL + "CartModule/DeleteCart", payload, { headers });
};

const PlaceOrder = (payload) => {
  console.log("PlaceOrder", payload);
  return axios.post(B_URL + "CartModule/PlaceOrder", payload, { headers });
};

const AddTopUp = (payload) => {
  console.log("AddTopUp", payload);
  return axios.post(B_URL + "TopUpModule/AddTopUp", payload, { headers });
};

const GetTopUp = (payload) => {
  console.log("GetTopUp", payload);
  return axios.post(B_URL + "TopUpModule/GetTopUp", payload, { headers });
};
const GetReviewData = (payload) => {
  console.log("GetReviewData", payload);
  return axios.post(B_URL + "ReviewModule/GetReviewData", payload, { headers });
};

const GetOrdersProductForReview = (payload) => {
  console.log("GetOrdersProductForReview", payload);
  return axios.post(B_URL + "OrderModule/GetOrdersProductForReview", payload, { headers });
};

const MyReviews = (payload) => {
  console.log("MyReviews", payload);
  return axios.post(B_URL + "OrderModule/MyReviews", payload, { headers });
};

const AddReview = (payload) => {
  console.log("AddReview", payload);
  return axios.post(B_URL + "OrderModule/AddReview", payload, { headers });
};

const GetRewards = (user_id) => {
  console.log("user_id", user_id);

  var payload = {
    "functionName": "GetRewardsHistory",
    "postData": {
      "user_id": user_id
    }
  }

  return axios.post(B_URL + "RewardModule/GetRewardsHistory", payload, { headers });
};

const RedeemPoints = (data) => {
  console.log("data", data);
  var payload = {
    "functionName": "RewardToPayment",
    "postData": {
      "points": data.points,
      "user_id": data.user_id
    }
  }

  return axios.post(B_URL + "RewardModule/RewardToPayment", payload, { headers });
};

  
  const GetDashboardSummary = (sessionID, payload) => {
  console.log("GetDashboardSummary:-", payload);
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "ReportsModule/DashboardSummary", payload, { headers });
};


const uploadReceipt = (receipt, user_id, business_id) => {
  console.log("user_id", user_id);

  var payload = {
    "functionName": "processInvoice",
    "postData": {
      "user_id": user_id,
      "receipt": receipt,
      "business_id": business_id
    }
  }

  return axios.post(B_URL + "E_InvoiceModule/processInvoice", payload, { headers });
};

const DashboardSummary = (payload) => {
  const token = localStorage.getItem("session-id");
  const headers = {
    'Content-Type': 'application/json',
    'token': token,
  };
  return axios.post(B_URL + "ReportsModule/DashboardSummary", payload, { headers });
};;


const DashboardService = {
  GetReviewData,
  getAll,
  GetOrdersProductForReview,
  MyReviews,
  getInvoices,
  Get_User_Invoices,
  AddReview,
  AddTopUp,
  GetTopUp,
  uploadReceipt,
  PlaceOrder,
  DeleteCart,
  GetDashboardData,
  getAllBusiness,
  getAllCategories,
  getAllStatements,
  getAllProducts,
  GetCartList,
  GetProducctDetails,
  GeProductReviews,
  setCart,
  GetRewards,
  RedeemPoints,
  GetDashboardSummary,
  DashboardSummary

};

export default DashboardService;